import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

export interface IHtableRow {
  tableRowPadding?: string;
}

export const HTableRow = Styled.div<IHtableRow>`
  padding: ${props => props.tableRowPadding};
  display: block;
  ${media.small`
    display: flex;
  `}
`;

HTableRow.defaultProps = {
  tableRowPadding: '1em 0em 0em',
};

export const HTableKey = Styled.div`
  color: ${({ theme: { text } }) => text.colorText};
  font-weight: 700;
  text-transform: capitalize;
  width: 50%;
  font-size: 1.4rem;
`;

export const HTableValue = Styled.div`
  color: ${({ theme: { text } }) => text.colorText};
  white-space: pre-line;
`;
